import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Contact from "@/services/contact/contact";
import type { SendContactChatMessagePayload } from "@/dtos/ContactChat.dto";

export function useSendContactChatMessage() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: SendContactChatMessagePayload) => {
      const response = await Contact.sendChatMessage(payload);
      return response.data.data;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["contact-chat-messages", variables.contactId],
      });
      queryClient.invalidateQueries({
        queryKey: ["interactionCounts", variables.contactId],
      });
    },
  });
}
